<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <!-- Table Card -->
        <v-card class="table-card mt-6">

          <div class="table-header flex justify-between align-center flex-wrap">
            <!-- Left side: search + clear -->
            <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 8px;">
              <InputText v-model="filters['global'].value" placeholder="Search Users..." />
              <Button type="button" icon="pi pi-filter-slash" label="Clear" variant="outlined" @click="clearFilters" />
            </div>
            <button type="button" :disabled="loading" class="theme-button px-5"
              @click="resetForm(); isEditing = false; editingId = null; partnerDialog = true">
              <span v-if="!loading"><v-icon start>mdi-content-save-cog-outline</v-icon> Save Partner </span>
            </button>
          </div>

          <!-- PrimeVue DataTable with search -->
          <DataTable v-model:filters="filters" :value="iPartners" paginator :rows="10" dataKey="uuid" stripedRows
            class="modern-table" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem"
            filterDisplay="menu" @row-click="goToDetails" selectionMode="single"
            :globalFilterFields="['name', 'phone', 'email', 'website']">

            <!-- Empty table -->
            <template #empty>
              No Partner found.
            </template>

            <!-- Loading state -->
            <template #loading>
              Loading Partner...
            </template>

            <!-- Product Column -->
            <Column header="Name">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    <div class="product-name">{{ slotProps.data.name }}</div>
                  </div>
                </div>
              </template>
            </Column>

            <!--User Column-->
            <Column header="Email">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    <div class="product-name">{{ slotProps.data.email }}</div>
                  </div>
                </div>
              </template>
            </Column>

            <!--Phone Column-->
            <Column header="Phone">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ slotProps.data.phone }}
                  </div>
                </div>
              </template>
            </Column>

            <!--Type Column-->
            <Column header="Partner Type">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ capitalize(slotProps.data.partner_type) }}
                  </div>
                </div>
              </template>
            </Column>

            <!--Account Column-->
            <Column header="Account Number">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ slotProps.data.virtual_account_number }}
                  </div>
                </div>
              </template>
            </Column>

             <!--Account Column-->
            <Column header="Bank">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ slotProps.data.virtual_bank_name }}
                  </div>
                </div>
              </template>
            </Column>

             <!--Account Column-->
            <Column header="Account Name">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ slotProps.data.virtual_account_id }}
                  </div>
                </div>
              </template>
            </Column>

            <!--Address Column-->
            <Column header="Location">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ truncateHtml(slotProps.data.address) }}
                  </div>
                </div>
              </template>
            </Column>


            <!--Website Column-->
            <!-- <Column header="Website">
              <template #body="slotProps">
                <div class="product-cell">
                  <div>
                    {{ slotProps.data.website }}
                  </div>
                </div>
              </template>
            </Column> -->

            <!-- Created Column -->
            <Column header="Account Created At">
              <template #body="slotProps">
                {{ formatDateTime(slotProps.data.created_at) }}
              </template>
            </Column>

            <!-- Actions Column -->
            <Column header="" style="width:120px; border-radius: 10px;">
              <template #body="slotProps">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn icon v-bind="props" variant="text">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openPartnerEditModal(slotProps.data)">
                      Edit {{ slotProps.data.name }} Details
                    </v-list-item>
                  </v-list>
                  <v-list>
                    <v-list-item @click="regenerateNewVA(slotProps.data)" :loading="regeneratingVA">
                     Regenerate Virtual Account
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </Column>

          </DataTable>
        </v-card>
        <!-- ADD / EDIT PARTNER DIALOG -->
        <v-dialog v-model="partnerDialog" max-width="650">
          <v-card class="pa-6">

            <!-- Title -->
            <div class="text-h6 mb-4 text-center">
              <div class="text-h6 font-weight-bold">
                {{ isEditing ? "Update Partner" : "Add New Partner" }}
              </div>

              <!-- <v-btn
        icon
        variant="text"
        @click="partnerDialog = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn> -->
            </div>

            <!-- FORM -->
            <form @submit.prevent="handleCreatePartner">

              <v-row dense>

                <!-- Name -->
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.name" label="Partner Name" variant="outlined"
                    :rules="[v => !!v || 'Name is required']" />
                </v-col>

                <!-- Email -->
                <v-col cols="12" md="6">
                  <v-text-field v-if="!isEditing" v-model="form.email" label="Email" type="email" variant="outlined"
                    :rules="[v => !!v || 'Email is required']" />
                </v-col>

                <!-- Phone -->
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.phone" label="Phone Number" variant="outlined" />
                </v-col>

                <!-- type -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="form.partner_type"
                    label="Partner Type"
                    variant="outlined"
                    :items="partnerOptions"
                    item-title="label"
                    item-value="value"
                    :rules="[v => !!v || 'Partner Type is required']"
                  />
                </v-col>

                <!-- Website -->
                <v-col cols="12">
                  <v-text-field v-model="form.website" label="Website" variant="outlined"
                    placeholder="https://example.com" />
                </v-col>

                <v-col cols="12">
                  <v-text-field v-if="!isEditing" v-model="form.password" label="Password" type="password" variant="outlined" />
                </v-col>

                <!-- About -->
                <v-col cols="12">
                  <v-textarea v-model="form.about" label="About" variant="outlined" rows="3" />
                </v-col>

                <!-- Address -->
                <v-col cols="12">
                  <v-textarea v-model="form.address" label="Address" variant="outlined" rows="2" />
                </v-col>

                <!-- Partner Logo -->
                <v-col cols="12">
                  <v-file-input v-model="form.partner_image" label="Partner Logo" variant="outlined" prepend-icon="mdi-camera"
                    accept="image/*" />
                </v-col>

                <!-- Existing Image -->
                <v-col cols="12" v-if="existingImage">
                  <div class="text-caption mb-2">
                    Current Logo
                  </div>

                  <!-- <img :src="`${STORAGE_URL}/${existingImage}`" class="rounded-lg"
                    style="width: 120px; height: 120px; object-fit: cover;" /> -->
                    <img v-if="existingImage" :src="`${STORAGE_URL}/${existingImage}`" class="mt-3 rounded" width="120" />
                </v-col>

              </v-row>

              <!-- ACTIONS -->
              <div class="flex justify-center align-center  gap-3 pt-4"
                style="display:flex; justify-content:center; align-items:center; gap:12px; padding-top:16px;">

                <v-btn variant="outlined" @click="partnerDialog = false">
                  Cancel
                </v-btn>

                <v-btn color="black" type="submit" :loading="partnerLoading" :disabled="!isPartnerFormValid">
                  {{ isEditing ? "Update Partner" : "Save Partner" }}
                </v-btn>

              </div>

            </form>

          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
          snackbar.message }}
          <template #actions>
            <v-btn variant="text" @click="snackbar.show = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { partnerStore } from "@/store/partner"
import { capitalize, formatDateTime, getAllErrors, truncateHtml } from "@/util"
import { useRouter } from "vue-router"
import { STORAGE_URL } from "@/api/env"
import { addPartner, updatePartner, regenerateVirtualAccount } from "@/api/partner"


const pStore = partnerStore()
const router = useRouter()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const filters = ref({ global: { value: null, matchMode: "contains" } })
const partnerDialog = ref(false)
const partnerLoading = ref(false)
const isEditing = ref(false)
const editingId = ref(null)
const existingImage = ref("")
const regeneratingVA = ref(false)

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

const iPartners = computed(() => pStore?.partners || [])

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  
  try {
    if (typeof pStore.loadPartners === "function") {
      await pStore.loadPartners()
    }
  } catch (error) {
    console.error(error)
  }
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/* Clear filters */
const clearFilters = () => {
  filters.value = { global: { value: null, matchMode: "contains" } }
}

//clicking on the row
const goToDetails = (event) => {
  const row = event.data

  router.push({
    name: 'PartnerDetails',
    params: { id: row.uuid }
  })
}

const partnerOptions = [
  {
    label: 'Listing Partner',
    value: 'listing'
  },
  {
    label: 'Distribution Partner',
    value: 'distribution'
  }
]

//snackbar
const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

/**
 * FORM
 */
const form = ref({
  name: "",
  email: "",
  phone: "",
  about: "",
  website: "",
  address: "",
  password: "",
  partner_type: "",
  partner_image: null
})

/**
 * RESET FORM
 */
const resetForm = () => {
  form.value = {
    name: "",
    email: "",
    phone: "",
    about: "",
    website: "",
    address: "",
    password: "",
    partner_type: "",
    partner_image: null
  }
  existingImage.value = ""
}

/**
 * VALIDATION
 */
const isPartnerFormValid = computed(() => {
   // UPDATE validation
  if (isEditing.value) {
    return (
      form.value.name &&
      form.value.phone &&
      form.value.partner_type
    )
  }

  // CREATE validation
  return (
    form.value.name &&
    form.value.email &&
    form.value.password &&
    form.value.phone && 
    form.value.partner_type
  )
})


/**
 * CREATE / UPDATE PARTNER
 */
const handleCreatePartner = async () => {
  partnerLoading.value = true

  try {
    const payload = new FormData()

    payload.append("name", form.value.name)
    //payload.append("email", form.value.email)
    payload.append("phone", form.value.phone)
    payload.append("website", form.value.website)
    payload.append("address", form.value.address)
    payload.append("about", form.value.about)
    payload.append("partner_type", form.value.partner_type)
    if (!isEditing.value) {
      payload.append("email", form.value.email)
      payload.append("password", form.value.password)
    }
    if (form.value.partner_image) {
      payload.append("partner_image", form.value.partner_image)
    }

    if (isEditing.value) {
      await updatePartner(editingId.value, payload)
    } else {
      await addPartner(payload)
          
    }

    await pStore.loadPartners()

    showSnackbar(
      isEditing.value
        ? "Partner updated successfully"
        : "Partner created successfully"
    )

    setTimeout(() => { partnerDialog.value = false}, 2000)

    //resetPartnerForm()

  } catch (e) {

    const msg = getAllErrors(e)

    showSnackbar(
      msg || "Failed to save partner",
      "error"
    )

  } finally {
    partnerLoading.value = false
  }
}

/**
 * OPEN EDIT MODAL
 */
const openPartnerEditModal = (item) => {

  isEditing.value = true
  editingId.value = item.uuid

  form.value.name = item.name || ""
  //form.value.email = item.email || ""
  form.value.about = item.about || ""
  form.value.phone = item.phone || ""
  form.value.partner_type = item.partner_type || ""
  form.value.website = item.website || ""
  form.value.address = item.address || ""

  // file inputs cannot preload images
  form.value.partner_image = null

  existingImage.value = item.partner_image || ""
  

  partnerDialog.value = true
}

const regenerateNewVA = async (partner) => {

  const partnerId = partner.uuid
  if (!confirm(`Regenerate the virtual account for ${partner.name}?`)) {
    return
  }

  regeneratingVA.value = true

  try {
    const res = await regenerateVirtualAccount(partnerId)

    showSnackbar(res.data?.message || "Virtual account regenerated successfully")

    // Reload the partner's table, new account number is displayed
    await pStore.loadPartners()
  } catch (error) {
     const msg = getAllErrors(error)
    showSnackbar(
      msg || "Failed to regenerate virtual account",
      "error"
    )
   
  } finally {
    regeneratingVA.value = false
  }
}

</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #16a34a;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

/* Search input */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #64748b;
}

.search-wrapper input {
  padding-left: 28px;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

/* Table */
.modern-table {
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.p-datatable-tbody>tr {
  cursor: pointer;
}

.p-datatable-tbody>tr:hover {
  background-color: #f5f5f5;
}
</style>
